import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    headerTitle: {
      fontWeight: "bold",
      fontSize: "16px",
      lineHeight: "32px",
      color: "#333333",
    },
    more: {
      color: "#1C8AB5",
      fontSize: "14px",
      lineHeight: "32px",
      textDecorationLine: "underline",
      padding: 0,
      margin: 0,
      border: "none",
      "&:hover": {
        padding: 0,
        border: "none",
        color: "#21A0D2",
      },
      "&:visited": {
        color: "#006c97",
      },
    },
  });

export const useStyles = makeStyles(styles);
